import styled from "styled-components";

export const MobileMenuItemContainerBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
  margin: 1rem;
  background-color: ${({theme}) => theme.colors.background};
`